import styled from 'styled-components';

export const StyledSubTitle = styled.p`
  margin-bottom: .5rem;
`;

export const StyledTitle = styled.h2`
  margin-bottom: 0;
`;
